import { useCallback } from 'react';

import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import useInsightExplorerStore from '@/stores/InsightExplorerStore';

import type { HierarchyNodeData } from '../components/InsightExplorerSidebar/HierarchyNavigator/HierarchyNavigator';
import { insightExplorerUtils } from '../utils/insight-explorer.utils';

const useExplorerSelect = () => {
  const wr = useWorkspaceRouter();
  const { setState } = useInsightExplorerStore();
  const selectNode = useCallback(
    (node: HierarchyNodeData) => {
      setState({
        selectedNode: node,
        by: node.node_type,
      });
      const field = insightExplorerUtils.getFieldFromNodeType(node.node_type);
      wr.push(`/insight-explorer/${field}/${node.id}`);
    },
    [setState, wr],
  );

  return selectNode;
};

export default useExplorerSelect;
